import "./App.css";
import AllRoutes from "./components/Router.js";

function App() {

  return (
    <>
      <AllRoutes />
    </>
  );
}

export default App;
